import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FavoriteIcon from '@icons/FavoriteIcon';
import ShareIcon from '@icons/ShareIcon';
import { mediaQueries } from '@general/breakpoints';

const Container = styled.div`
    height: 100%;
    min-height: 350px;
    padding-bottom: 68px;

    @media ${mediaQueries.sm} {
        min-height: 360px;
    }

    @media ${mediaQueries.lg} {
        min-height: 420px;
    }

    @media ${mediaQueries.xl} {
        min-height: 430px;
    }
`;

const BaseCard = ({
    cardClasses = '',
    id,
    type,
    title,
    url,
    showFavoriteIcon = true,
    showShareIcon = true,
    isFavorite,
    onFavorite,
    isLoadingFavorite,
    imageBlock,
    contentBlock,
}) => (
    <Container className={`card mb-0 ${cardClasses}`}>
        {imageBlock}
        <div className="py-0 card-block">{contentBlock}</div>
        <div className="p-3 card-icons w-100 d-flex justify-content-start align-items-center">
            {showShareIcon && (
                <div className="mr-1rem">
                    <ShareIcon title={title} url={url} />
                </div>
            )}

            {showFavoriteIcon && (
                <FavoriteIcon
                    id={id}
                    type={type}
                    isFavorite={isFavorite}
                    isLoading={isLoadingFavorite}
                    onClick={onFavorite}
                />
            )}
            {!showFavoriteIcon && <ShareIcon title={title} url={url} classNames="mr-3" />}
        </div>
    </Container>
);

BaseCard.propTypes = {
    cardClasses: PropTypes.string,
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string,
    url: PropTypes.string.isRequired,
    showFavoriteIcon: PropTypes.bool,
    showShareIcon: PropTypes.bool,
    isFavorite: PropTypes.bool,
    onFavorite: PropTypes.func,
    isLoadingFavorite: PropTypes.bool,
    imageBlock: PropTypes.any,
    contentBlock: PropTypes.any,
    isLoggedIn: PropTypes.bool,
};

export default BaseCard;
